import React from 'react';
import styles from './overlay.css';

import scenarios_json from '../../data/scenarios.json'
import devices_json from '../../data/devices.json'

import Lang from '../../i18n'
import { withRouter } from 'react-router-dom'

var classNames = require('classnames');

class Overlay extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      scenario: props.scenario,
      selectedScenario: props.scenarioData,
      currency: props.currency,
      deviceData: props.deviceData,
      currentlySelectedScenario: props.scenarioData,
      hasChangedSelection: false
    }
  }
  
  setActiveScenario(scenario) {
    this.setState({
      scenario
    }, () => {
      this.prepareScenarioList()
    })
  }
  
  saveOverlay(ev) {
    ev.preventDefault();
    if (this.state.scenario) {
      this.props.triggerScenarioChange(this.state.scenario)
    }
    this.props.showOverlay(ev, false)
  }

  returnDevicePricingDataView = () => {
    const devices = this.props.deviceData.map( (device) => {
      return(
        <div key={device.id} className={styles.devicePricingContainer}>
          <h4>{Lang.translate(`calculator:${device.localeName}`, this.props.location.pathname)}</h4>
          <span>{this.props.currency.symbol} {Number(device.unit_price).toLocaleString('de-DE')}</span>
        </div>
      )
    });
    return devices;
  }

  returnScenarioOverviewView = () => {
    const currentScenario = this.props.scenarioData
    const scenarios = scenarios_json.map((scenario) => {
      const id = scenario.id
      const deviceList = scenario.items.map((device) => {
        const deviceItem = devices_json.filter(devices => devices.id === device.id)[0]
        return(
          <li key={`${device.id}-device`}>
            <span className={styles.showSmaller}>
            {deviceItem.name}:&nbsp;</span>
            {device.qty}
          </li>
        )
      })
      return(
        <div key={`${id}-scenario`} className={classNames(styles.scenarioLineItem, currentScenario.id === id ? styles.activeScenario : '', this.state.currentlySelectedScenario.id === id && this.state.currentlySelectedScenario.id !== currentScenario.id && this.state.hasChangedSelection ? styles.currentlySelectedScenario : '')} onClick={() => this.selectScenario(scenario)}>
          <ul>
            <li><span className={styles.showSmaller}>Scenario:&nbsp;</span>{scenario.short_name}</li>
            {deviceList}
            <li><span className={styles.showSmaller}>{Lang.translate('calculator:capacity', this.props.location.pathname)} ({Lang.translate('calculator:pieceHours', this.props.location.pathname)}):&nbsp;</span>{scenario.capacity}</li>
          </ul>
        </div>
      )
    })
    return scenarios
  }

  selectScenario = (scenario) => {
    this.setState({
      currentlySelectedScenario: scenario,
      hasChangedSelection: true
    }, () => {
      console.log(scenario)
    })
  }

  toggleOverlay = (ev) => {
    this.setState({
      currentlySelectedScenarioId: this.props.scenarioData.id,
      hasChangedSelection: false
    })
    this.props.showOverlay(ev, false)
  }

  handleScenarioChange = () => {
    this.setState({
      hasChangedSelection: false
    })
    this.props.triggerScenarioChange(this.state.currentlySelectedScenario)
    this.props.showOverlay(null, false)
  }
  
  render() {
    const devices = this.returnDevicePricingDataView();
    const scenarios = this.returnScenarioOverviewView();
    return (
      <div className={ styles.overlay } style={this.props.shouldShow ? {opacity: 1, visibility: 'visible'} : {opacity: 0, visibility: 'hidden'} }>
        <div className={ styles.overlayInner }>
          <div className={ styles.close }>
            <a onClick={ (ev) =>  this.toggleOverlay(ev)}>
              <svg width="25px" height="25px" viewBox="0 0 62 62" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <defs></defs>
                  <g id="Symbols" stroke="none" fill="none">
                      <g id="Exit" transform="translate(1.000000, 1.000000)">
                          <g>
                              <circle id="Oval-2" stroke="#FFFFFF" fill="#0D2EA0" cx="30" cy="30" r="30"></circle>
                              <g id="Group" transform="translate(30.500000, 30.500000) rotate(45.000000) translate(-30.500000, -30.500000) translate(13.000000, 13.000000)" fill="#FFFFFF">
                                  <rect id="Rectangle-8" x="0" y="15" width="35" height="5"></rect>
                                  <rect id="Rectangle-8" x="15" y="0" width="5" height="35"></rect>
                              </g>
                          </g>
                      </g>
                  </g>
              </svg>
            </a>
          </div>
          <div className={styles.deviceDataContainer}>
            {devices}
          </div>

          <div className={styles.scenarioOverviewList}>
            <ul className={styles.scenarioOverviewHeader}>
              <li>Scenario</li>
              <li>{Lang.translate('calculator:gtxprinter', this.props.location.pathname)}</li>
              <li>{Lang.translate('calculator:transferpresse', this.props.location.pathname)}</li>
              <li>{Lang.translate('calculator:pretreatmaker', this.props.location.pathname)}</li>
              <li>{Lang.translate('calculator:pretreatmakerLine', this.props.location.pathname)}</li>
              <li>{Lang.translate('calculator:tunneltrockner', this.props.location.pathname)}</li>
              <li>{Lang.translate('calculator:capacity', this.props.location.pathname)} ({Lang.translate('calculator:pieceHour', this.props.location.pathname)})</li>
            </ul>
            {scenarios}
          </div>

          <button className={classNames(styles.button, this.state.hasChangedSelection ? styles.buttonActive : '')} onClick={() => this.handleScenarioChange()}>{Lang.translate('calculator:apply', this.props.location.pathname)}</button>
            
        </div>
      </div>
    )
  }
}

export default withRouter(Overlay)


// WEBPACK FOOTER //
// ./src/components/overlay/overlay.js